import React, { useEffect, useRef } from 'react';
import { SizeContainer, ToastContainer, Wrapper, Content, CookiesContainer } from './admin-layout.styles';
import { Header } from '../header/header';
import { Sidebar } from '../sidebar/sidebar';
import { useToastContext } from '@shared/context/toastContext/toast-context';
import { AdminRouter } from '@app/router/admin-router';
import { Cookies } from '../cookies/cookies';
import { COOKIES_NOTIFY_ID } from '../cookies/constants';
import { Footer } from '@shared/ui/footer/footer';
import { useDispatch } from 'react-redux';
import { setLayoutAdmin } from '@shared/store/model/slice';
import { useUserInfoMutation } from '@entities/current-user/api/credentials-user-api';
import { useHistory, useLocation } from 'react-router-dom';
import { CurrentUserInfoEnum, UTMInfoKeysEnum } from '@entities/current-user/api/credentials-user-types';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { ROUTE_ADMIN_PRODUCT_BASE } from '@shared/config/routes/routes';
import { useLazyProductAvailableListQuery } from '@entities/product/api/product-api';
import { useCurrentUserUtm } from '@entities/current-user/libs/hooks/use-current-user-utm/use-current-user-utm';

export const AdminLayout: React.FC = () => {
    const dispatch = useDispatch();
    const { pathname, search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const history = useHistory();
    const ref = useRef<HTMLDivElement>(null);
    const { setToastContainerRef } = useToastContext();
    const user = useCurrentUserSelector();
    const [editUserInfo] = useUserInfoMutation();
    const [getProducts, getProductsResult] = useLazyProductAvailableListQuery();
    const utmInfo = useCurrentUserUtm();

    useEffect(() => {
        dispatch(setLayoutAdmin(ref.current));
    }, [ref]);

    useEffect(() => {
        const lkProduct = getProductsResult.data?.items[0];

        if (lkProduct) {
            history.push(`${ROUTE_ADMIN_PRODUCT_BASE}/${lkProduct.id}`);
        }
    }, [getProductsResult.data?.items]);

    useEffect(() => {
        if (user && utmInfo) {
            editUserInfo({
                userId: user.id,
                type: CurrentUserInfoEnum.UTM,
                data: utmInfo,
            });
            history.replace(pathname + '?' + searchParams.toString());

            if (utmInfo[UTMInfoKeysEnum.LKProduct]) {
                getProducts({
                    codes: [utmInfo[UTMInfoKeysEnum.LKProduct]],
                    take: 1,
                });
            }
        }
    }, [user, utmInfo]);

    return (
        <Wrapper ref={ref}>
            <Header />
            <SizeContainer>
                <Sidebar />
                <Content>
                    <AdminRouter />
                </Content>
                <ToastContainer ref={setToastContainerRef} />
                <CookiesContainer id={`${COOKIES_NOTIFY_ID}`} />
            </SizeContainer>
            <Cookies />
            <Footer />
        </Wrapper>
    );
};
